import $http from '@/plugins/axios'
import store from '@/store'
import { LAYOUT_TYPES } from '../store/modules/layout'

export const queryCTF = async (query, checkLastUpdate = true) => {
  const res = await $http().get(buildCTFQuery() + query)
  if (checkLastUpdate) {
    const lastUpdateDates = res.includes.Entry.map(entry => new Date(entry.sys.updatedAt))
    store.dispatch(LAYOUT_TYPES.actions.setPageLastUpdateTime, lastUpdateDates)
  }
  return res
}

/**
 * fetches a single entry from Contentful, useful for nested content
 * @param {String} entryId
 */
export const queryEntryCTF = async (entryId) => {
  const res = await $http().get(buildCTFQuery(entryId))
  const lastUpdate = [store.state.layout.pageLastUpdatedDate]
  store.dispatch(LAYOUT_TYPES.actions.setPageLastUpdateTime, lastUpdate)
  return res
}

export const downloadAssetCTF = async (assetId) => {
  return await $http().get(process.env.VUE_APP_CTF_API_URL + `/spaces/${process.env.VUE_APP_CTF_SPACE}/environments/${process.env.VUE_APP_CTF_ENV}/assets/${assetId}?access_token=${process.env.VUE_APP_CTF_TOKEN}`)
}

const buildCTFQuery = (entityId = '') => {
  return process.env.VUE_APP_CTF_API_URL + `/spaces/${process.env.VUE_APP_CTF_SPACE}/environments/${process.env.VUE_APP_CTF_ENV}/entries${entityId ? '/' + entityId : ''}?access_token=${process.env.VUE_APP_CTF_TOKEN}`
}

export const sortCTFEntries = (links, entries) => {
  if (!links || !entries) {
    return
  }
  // sort includes entries by group tile order
  const sliceIds = links.map(s => s.sys.id)
  return [...entries]
    .filter(e => sliceIds.includes(e.sys.id))
    .map(e => {
      e.sys.order = sliceIds.indexOf(e.sys.id)
      return e
    }).sort((a, b) => a.sys.order - b.sys.order)
}

/**
 * @param {String} id Id of desired asset
 * @param {Array} assets Contentful assets array
 */
export const getCTFAsset = (id, assets) => {
  if (!id || !assets || !assets.length) {
    return
  }
  return assets.find((a) => a.sys.id === id)
}
